import _TreeSelect from './TreeSelect';

import './style/index.js';

export type { TreeSelectProps } from './TreeSelect';
export * from './type';

export const TreeSelect = _TreeSelect;
export default TreeSelect;
